import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-gender-field',
  templateUrl: './gender-field.component.html',
  styleUrls: ['./gender-field.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, IonicModule, TranslateModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GenderFieldComponent),
      multi: true
    }
  ]
})
export class GenderFieldComponent implements ControlValueAccessor {
  @Input() submitted: boolean = false;
  @Input() role: string = '';
  @Input() required: boolean = false;

  genderModal: boolean = false;
  genderOptions = [
    { value: 'Homme', label: 'FORM.LABELS.GENDER_2' },
    { value: 'Femme', label: 'FORM.LABELS.GENDER_1' },
    { value: 'Autre', label: 'FORM.LABELS.OTHER' }
  ];

  genderForm: FormGroup;

  private onChange = (value: any) => {};
  private onTouched = () => {};

  constructor(private fb: FormBuilder, private translate: TranslateService) {
    this.genderForm = this.fb.group({
      gender: ['', this.getValidators()]
    });

    this.genderForm.valueChanges.subscribe(value => {
      this.onChange(value);
    });
  }

  private getValidators() {
    return this.required ? [Validators.required] : [];
  }

  openGenderModal(val: boolean) {
    this.genderModal = val;
  }

  selectGender(gender: { value: string, label: string }) {
    this.genderForm.patchValue({ gender: gender.value });
    this.openGenderModal(false);
  }

  getGenderDisplayValue(): string {
    const genderValue = this.genderForm.get('gender')?.value;
    if (!genderValue) return '';
    
    const option = this.genderOptions.find(opt => opt.value === genderValue);
    return option ? this.translate.instant(option.label) : genderValue;
  }

  // Update validators when role changes
  updateRole(role: string) {
    this.role = role;
    const genderControl = this.genderForm.get('gender');
    if (genderControl) {
      genderControl.setValidators(this.getValidators());
      genderControl.updateValueAndValidity();
    }
  }
  // Update validators when required changes
  ngOnChanges() {
    const genderControl = this.genderForm.get('gender');
    if (genderControl) {
      genderControl.setValidators(this.getValidators());
      genderControl.updateValueAndValidity();
    }
  }

  writeValue(value: any): void {
    if (value) {
      this.genderForm.patchValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.genderForm.disable();
    } else {
      this.genderForm.enable();
    }
  }

  get genderControl() {
    return this.genderForm.get('gender');
  }
}
